import React, { useContext, useEffect, useState } from 'react';
import { compose, prop } from 'ramda';
import { withProps } from 'recompose';
import { withPortlet } from 'js/components/system/Portlet';
import { useMountEffect } from 'js/hooks/useMountEffect';
import { fetchDetails, setDetailsAction, subscribeDetails, unsubscribeDetails, updateDetailsAction } from './actions';
import { DetailsContext } from './context';
import { withDetailsContext } from './withContext';
import { usePushSubscription } from 'server';
import { useAppSelector } from 'js/store/hooks';

export const useFetchingDetails = (props) => {
    const { leaderboardId, topCompetitorsCount, fieldsWhitelist, networkId } = props;
    const { state = {}, dispatch } = useContext(DetailsContext);
    const [error, setError] = useState();
    const { details } = state;
    const isGamesLoaded = useAppSelector(prop('isGamesLoaded'));

    useMountEffect((isMounted) => {
        if (!isGamesLoaded) {
            return;
        }

        fetchDetails({
            leaderboardId,
            topCompetitorsCount,
            networkId,
            fieldsWhitelist
        })
            .then(({ data }) => isMounted() && dispatch(setDetailsAction(data.leaderboardDetails)))
            .catch(({ data }) => isMounted() && setError(data));
    }, [isGamesLoaded]);

    return { details, error };
};

export const useSubscriptionOnDetailsUpdate = (props) => {
    const {
        leaderboardId,
        topCompetitorsCount,
        networkId,
        notificationFieldsWhitelist
    } = props;

    useEffect(() => {
        subscribeDetails({
            leaderboardId,
            topCompetitorsCount,
            networkId,
            notificationFieldsWhitelist
        });

        return () => unsubscribeDetails({ leaderboardId });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

export const useDetailsUpdate = () => {
    const { dispatch } = useContext(DetailsContext);

    usePushSubscription(71032, () => message => dispatch(updateDetailsAction(message.data)));
};

export const withFetch = compose(
    withProps(useFetchingDetails)
);

export const withUpdates = compose(
    Wrapped => (props) => {
        useSubscriptionOnDetailsUpdate(props);
        useDetailsUpdate();

        return <Wrapped {...props} />;
    }
);

export const withDetails = compose(
    withPortlet({ forLoggedIn: true }),
    withDetailsContext,
    withFetch
);

export const withDetailsAndUpdates = compose(
    withDetails,
    withUpdates
);

export default withDetailsAndUpdates;
